import React, {useContext} from "react";
import PropTypes from "prop-types";
import { LoginContext } from "../../../../services/api/authentication-api";
import { OrganizationGrid } from "../organization/OrganizationGrid";
import placeholderImage from "../../../../assets/icons/Illustration - Missing content.svg";
import {
  CustomActionsCell,
  CustomCell,
  CustomNamesCell,
} from "../organization/CommonUtil";

import NoPermissionTable from "../../../../components/no-permission-table/NoPermissionTable";

export const SubDepartmentGrid = (props) => {
  const { subDepartmentRolePrivilege, fetchEndpoint } = props;
  const user = useContext(LoginContext);
  if (!subDepartmentRolePrivilege) {
    return (
      <div style={{height: "500px"}}>
        <NoPermissionTable />;
      </div> )
  }

  const canArchive = user?.currentUser?.privileges?.["Sub-Department"]?.Delete;
  const canEdit = user?.currentUser?.privileges?.["Sub-Department"]?.Edit ?? false;

  const columns = [
    { field: "Name", title: "Name", render: true, export: true },
    {
      field: "DepartmentNamesString",
      title: "Departments",
      cells: { data: (props) => CustomNamesCell("DepartmentNames", props) },
      render: true,
      export: true
    },
    { field: "DefaultProjectTemplateName", title: "Default Project Template",  render: true, export: true },
    { field: "DefaultTaskTypeName", title: "Default Task Type",  render: true, export: true },
    {
      field: "Status",
      title: "Status",
      cells: { data: (props) => CustomCell("Status", props) },
      render: true,
      export: true
    },
    {
      field: "",
      title: "Actions",
      cells: {
        data: (props) =>
          CustomActionsCell(props, "/admin/organization/subdepartments/edit/", fetchEndpoint, "Sub-Department", canArchive, canEdit),
      },
      render: true,
      export: false
    },
  ];

  const placeholderTexts = {
    firstLine: `Create your first Sub-Department for the Organization by`,
    secondLine: `clicking the 'Create New Sub-Department'`,
  };

  return (
    <span data-testid="organization-grid">
      <OrganizationGrid
        {...props}
        type="SubDepartment"
        privilegeKey="Sub-Department"
        createPath="/admin/organization/subdepartments/create/0"
        columns={columns}
        exportFileName="Sub-Departments-Export"
        placeholderTexts={placeholderTexts}
        placeholderImage={placeholderImage}
      />
    </span>
  );
};

SubDepartmentGrid.propTypes = {
  fetchEndpoint: PropTypes.func,
  subDepartmentRolePrivilege: PropTypes.bool,
};
